import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Handshake, WhatsappLogo } from "@phosphor-icons/react";

export function PromotersTab() {
  const [data, setData] = useState(null);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    api.get("/admin/promoters").then(r => setData(r.data)).catch(() => toast.error("Error cargando promotores"));
  }, []);

  if (!data) return <p className="text-white/40 text-center py-12">Cargando promotores…</p>;

  const fmtD = (iso) => iso ? new Date(iso).toLocaleDateString("es-MX", { day: "2-digit", month: "short", year: "numeric" }) : "";
  const registerUrl = `${window.location.origin}/promotores`;

  return (
    <div className="space-y-5" data-testid="promoters-tab">
      <div className="rounded-2xl border border-[#B4F34A]/30 bg-[#B4F34A]/5 p-5">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <h3 className="font-display text-lg font-bold flex items-center gap-2">
              <Handshake size={18} weight="fill" className="text-[#B4F34A]" /> Programa de promotores
            </h3>
            <p className="text-sm text-white/60 mt-1">
              {data.promoters.length} promotores · {data.total_referred} clientes referidos
            </p>
          </div>
          <button
            onClick={() => {
              const text = encodeURIComponent(`🤝 Regístrate como promotor de Tu MusiKa y obtén tu número:\n${registerUrl}`);
              window.open(`https://wa.me/?text=${text}`, "_blank");
            }}
            className="px-4 py-2.5 rounded-full bg-[#25D366] hover:bg-[#1FB858] text-black text-sm font-semibold flex items-center gap-2"
            data-testid="promoters-share-link"
          >
            <WhatsappLogo weight="fill" size={16} /> Invitar promotores
          </button>
        </div>
        <p className="text-xs text-white/40 mt-3 font-mono break-all">Enlace de registro: {registerUrl}</p>
      </div>

      {data.promoters.length === 0 && (
        <p className="text-white/40 text-center py-10">Aún no hay promotores registrados.</p>
      )}

      <div className="space-y-2" data-testid="promoters-list">
        {data.promoters.map(p => (
          <div key={p.id} className="rounded-2xl bg-[#121212] border border-white/5 p-4" data-testid={`promoter-${p.code}`}>
            <div className="flex flex-wrap items-center gap-3">
              <span className="font-display font-black text-xl tracking-widest text-[#FFB800] bg-[#FFB800]/10 border border-[#FFB800]/30 rounded-xl px-3 py-1.5">
                {p.code}
              </span>
              <div className="flex-1 min-w-[180px]">
                <p className="font-display font-bold">{p.name}</p>
                <p className="text-xs text-white/50">{p.phone} · Registrado: {fmtD(p.created_at)}</p>
              </div>
              <button
                onClick={() => setExpanded(expanded === p.code ? null : p.code)}
                className={`px-3 py-2 rounded-full text-xs font-semibold ${p.client_count > 0 ? "bg-[#B4F34A]/15 text-[#B4F34A] hover:bg-[#B4F34A]/25" : "bg-white/5 text-white/40"}`}
                disabled={p.client_count === 0}
                data-testid={`promoter-clients-btn-${p.code}`}
              >
                {p.client_count} cliente{p.client_count === 1 ? "" : "s"}
              </button>
            </div>
            {expanded === p.code && p.clients.length > 0 && (
              <div className="mt-3 pt-3 border-t border-white/5 space-y-1.5" data-testid={`promoter-clients-${p.code}`}>
                {p.clients.map(c => (
                  <div key={c.id} className="flex flex-wrap items-center justify-between gap-2 text-sm bg-[#0a0a0a] rounded-lg px-3 py-2">
                    <span className="text-white/80">{c.name}</span>
                    <span className="text-white/40 text-xs">{c.phone} · {fmtD(c.created_at)}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {data.unmatched_clients.length > 0 && (
        <div className="rounded-2xl border border-[#FF4B00]/30 bg-[#FF4B00]/5 p-4" data-testid="promoters-unmatched">
          <p className="font-display font-bold text-sm mb-2 text-[#FF4B00]">
            ⚠️ Clientes con número de promotor NO registrado
          </p>
          <div className="space-y-1.5">
            {data.unmatched_clients.map(c => (
              <div key={c.id} className="flex flex-wrap items-center justify-between gap-2 text-sm bg-[#0a0a0a] rounded-lg px-3 py-2">
                <span className="text-white/80">{c.name} <span className="font-mono text-[#FF4B00]">#{c.promoter_code}</span></span>
                <span className="text-white/40 text-xs">{c.phone} · {fmtD(c.created_at)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
